import React from 'react';
import { enums, Panel, Label } from 'console-kit';

const JSHelp = () => (
  <Panel
    header="Javascript Help"
    hasBorder={false}
    padding={{
      vertical:   enums.sizes.X4,
      horizontal: enums.sizes.X4,
    }}
  >
    <div className="help-info-column__content">
      <Label text="OneTrust's Cookie Consent software can be used across multiple domains. To enable OneTrust cookie tracking for Grow experiences, please copy the embed code and place it on your website before the closing </body> tag." />
    </div>
  </Panel>
);

export default JSHelp;
